import React, { type ChangeEvent, useCallback, useContext, useMemo, useState } from "react";

import { faSearch, faTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { debounce } from "lodash";

import { ActionItemsContext } from "~/actionItems/newActionItems/ActionItemsContext";

import styles from "./Filters.module.css";

export default function Search() {
	const { filters } = useContext(ActionItemsContext);
	const { search: initialSearch, onChangeSearch } = filters;
	const [search, setSearch] = useState<string>(initialSearch);

	const debouncedOnChangeSearch = useMemo(() => debounce(onChangeSearch, 500), [onChangeSearch]);
	const onChange = useCallback(
		(event?: ChangeEvent<HTMLInputElement>) => {
			const newSearch = event?.target.value ?? "";
			setSearch(newSearch);
			debouncedOnChangeSearch(newSearch.toLowerCase());
		},
		[debouncedOnChangeSearch],
	);

	const onClearSearch = useCallback(() => onChange(), [onChange]);

	return (
		<label className={styles.search}>
			<FontAwesomeIcon fixedWidth icon={faSearch} />
			<input type="search" placeholder="Search" value={search} onChange={onChange} />
			{search && (
				<button title="Clear search" className={styles.searchClearButton} onClick={onClearSearch}>
					<FontAwesomeIcon fixedWidth icon={faTimes} />
				</button>
			)}
		</label>
	);
}
